import React from 'react';
import { useParams } from 'react-router-dom';
import UserVhostDetail from '../../../shared/pages/host_shared/VhostDetail';
import AdminResourcePlanBar from '../../components/billing/AdminResourcePlanBar';

/**
 * Admin端虚拟主机详情页面
 * 复用用户端的VhostDetail组件，所有功能100%相同；顶部加所属用户 / 套餐 / 到期（后台改套餐走 AdminSubscriptionEditModal）
 */
const AdminVhostDetail = () => {
    const { id } = useParams();
    return (
        <>
            <AdminResourcePlanBar type="host_shared" id={id} />
            <UserVhostDetail />
        </>
    );
};

export default AdminVhostDetail;
